"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpChevronIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const constants_1 = require("../constants");
/**
 * Standard up chevron icon.
 */
function UpChevronIcon(props) {
    const { className, "data-testid": dataTestId, fill = "black", size = constants_1.Sizes.Large } = props;
    return ((0, jsx_runtime_1.jsx)("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: fill, xmlns: "http://www.w3.org/2000/svg", className: className, "data-testid": dataTestId, children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.5607 16.5607C20.9749 17.1464 20.0251 17.1464 19.4393 16.5607L12 9.12132L4.56066 16.5607C3.97487 17.1464 3.02513 17.1464 2.43934 16.5607C1.85355 15.9749 1.85355 15.0251 2.43934 14.4393L10.9393 5.93934C11.5251 5.35355 12.4749 5.35355 13.0607 5.93934L21.5607 14.4393C22.1464 15.0251 22.1464 15.9749 21.5607 16.5607Z" }) }));
}
exports.UpChevronIcon = UpChevronIcon;
//# sourceMappingURL=UpChevronIcon.js.map